import { useRouteError } from 'react-router-dom'
import ErrorBoundary from './ErrorBoundary'

const RouterErrorBoundary = () => {
  const error = useRouteError()
  return <ErrorBoundary routerError={error} />
}

export default RouterErrorBoundary
